import { formatItemAmount } from '../model';
import type { AnalyticsDashSegment } from '../model';

interface DashBarProps {
    isUahMode: boolean;
    segments: AnalyticsDashSegment[];
    profitabilityLabel: string;
}

const DashBar = ({ isUahMode, segments, profitabilityLabel }: DashBarProps) => {
    const barSegments = segments.filter(
        (segment) => !segment.disabled && segment.bar !== false && segment.value > 0,
    );
    const barTotal = barSegments.reduce((sum, segment) => sum + segment.value, 0);
    const legend = segments.filter((segment) => segment.disabled || segment.value > 0);

    return (
        <div className="object-analytics-dash__viz">
            <div className="object-analytics-dash__bar" role="img" aria-label={profitabilityLabel}>
                {barTotal > 0
                    ? barSegments.map((segment) => (
                          <span
                              key={segment.key}
                              className={`object-analytics-dash__seg object-analytics-dash__seg--${segment.tone}`}
                              style={{ width: `${(segment.value / barTotal) * 100}%` }}
                              title={`${segment.label}: ${formatItemAmount(segment.value, isUahMode)}`}
                          />
                      ))
                    : null}
            </div>
            <ul className="object-analytics-dash__legend list-unstyled mb-0">
                {legend.map((segment) => (
                    <li
                        key={segment.key}
                        className={`object-analytics-dash__legend-item${segment.disabled ? ' is-disabled' : ''}`}
                    >
                        <span
                            className={`object-analytics-dash__dot object-analytics-dash__seg--${segment.tone}`}
                            aria-hidden="true"
                        />
                        <span className="text-muted">{segment.label}</span>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default DashBar;
